import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Geschatte {{orderMethod}}: {{day}} rond {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Bestelling geweigerd',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Bestelling ontvangen',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Je bestelling is bekeken',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Bestelling bevestigd',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Bestelling is klaar',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Bestelling wordt bezorgd',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Bestelling voltooid',
    },
  },
  labels: {
    today: 'Vandaag',
  },
  waiting_confirmation: {
    title: 'Wachten op bevestiging',
    description: 'Even geduld...',
  },
  pickup_time: {
    title: 'Afhaaltijd',
    description: 'Bevestigd door {{name}}',
  },
  delivery_time: {
    title: 'Bezorgtijd',
    description: 'Bevestigd door {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} heeft de tijd gewijzigd van {{initialTime}} naar {{currentTime}}',
  },
};
